import { Badge } from './badge';
import { Button } from './button';
import { Container } from './container';
import { Heading } from './heading';
import { Skeleton } from './skeleton';
import { Stepper } from './stepper';
import { Text } from './text';

export default {
  Badge,
  Button,
  Container,
  Heading,
  Skeleton,
  Stepper,
  Text,
};
